<div class="fl-filter-container">
  <form [formGroup]="form" class="flex w-fit flex-wrap">
    <div class="mr-5 mb-4 flex flex-col">
      <mat-label>{{ 'reports.form.selectTimeframe' | translate }}</mat-label>
      <mat-form-field class="input">
        <mat-select formControlName="timeframe">
          <mat-option *ngFor="let types of config.timeframeTypes" [value]="types.id">
            {{ types.name.split('-')[0] | translate: {month: translateMonth(types.name.split('-')[1])} }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="form.get('timeframe').value == TimeframeEnum.Custom" class="mr-5 mb-4 flex flex-col">
      <mat-label>{{ 'reports.form.datePickerFrom' | translate }}</mat-label>
      <mat-form-field>
        <input
          [matDatepicker]="picker1"
          [max]="form.get('end').value?.toString()"
          [placeholder]="'reports.form.datePickerFrom' | translate"
          formControlName="start"
          matInput />

        <button
          class="absolute right-8"
          mat-icon-button
          matSuffix
          type="button"
          *ngIf="form.get('start').value"
          (click)="clearDatePickerFrom()">
          <mat-icon>clear</mat-icon>
        </button>

        <mat-datepicker-toggle [for]="picker1" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>

    <div *ngIf="form.get('timeframe').value == TimeframeEnum.Custom" class="mr-5 mb-4 flex flex-col">
      <mat-label>{{ 'overview.form.datePickerTo' | translate }}</mat-label>
      <mat-form-field>
        <input
          [matDatepicker]="picker2"
          [min]="form.get('start').value?.toString()"
          [placeholder]="'overview.form.datePickerTo' | translate"
          formControlName="end"
          matInput />

        <button
          class="absolute right-8"
          mat-icon-button
          matSuffix
          type="button"
          *ngIf="form.get('end').value"
          (click)="clearDatePickerTo()">
          <mat-icon>clear</mat-icon>
        </button>

        <mat-datepicker-toggle [for]="picker2" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>

    <div
      *ngIf="form.get('timeframe').value == TimeframeEnum.CurrentWeek || form.get('timeframe').value == TimeframeEnum.PreviousWeek"
      class="mr-5 mb-4 flex flex-col">
      <week-picker
        [disableWeekStartDate]="form.get('start').value"
        [disabled]="!form.get('start').value"
        [label]="'peopleCount.weekToCompare' | translate"
        [range]="form.get('rangeCompare')"
        class="flex-1"></week-picker>
    </div>

    <div *ngIf="config.isAdmin" class="mr-5 mb-4 flex flex-col">
      <mat-label>{{ "peopleCount.customer" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="customer-dropdown">
        <mat-select [placeholder]="'contactPerson.modal.form.selectCustomer' | translate" formControlName="customer">
          <mat-option *ngFor="let customer of config.customers" [value]="customer">
            {{ customer.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="mr-5 mb-4 flex flex-col">
      <mat-label>{{ "peopleCount.channel" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="form-field-readonly channels-dropdown">
        <mat-select
          [placeholder]="'contactPerson.modal.form.selectChannels' | translate"
          class="w-full"
          formControlName="channels"
          multiple>
          <div (click)="selectAllChannels(form)" class="flex flex-row items-center p-1 pl-3 cursor-pointer">
            <app-icon [ngStyle]="{ cursor: 'pointer' }" iconName="check" size="md"></app-icon>
            <span class="ml-1">{{ "global.selectAll" | translate }}</span>
          </div>
          <mat-divider></mat-divider>
          <div
            (click)="clearChannels(form)"
            *ngIf="form.get('channels').value?.length"
            class="flex flex-row items-center p-1 pl-3 cursor-pointer">
            <app-icon [ngStyle]="{ cursor: 'pointer' }" iconName="close" size="md"></app-icon>
            <span class="ml-1">{{ "global.deselectAll" | translate }}</span>
          </div>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let channel of config.channels" [value]="channel">
            {{ channel.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="form.get('tracking')" class="mr-5 mb-4 flex flex-col">
      <mat-label>{{ "reports.form.tracking" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="form-field-readonly channels-dropdown">
        <mat-select [placeholder]="'reports.form.tracking' | translate" class="w-full" formControlName="tracking" multiple>
          <mat-option *ngFor="let option of trackingOptions" [value]="option.id">
            {{ option.name | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="config.screenFilter" class="mr-5 mb-4 flex flex-col">
      <flow-form-combobox
        formControlName="screenFilter"
        [label]="config.screenFilter.label ?? 'global.screens'"
        [placeholder]="config.screenFilter.label ?? 'global.screens'"
        [options]="config.screenFilter.options"
        [multiple]="true"
        [selectAll]="true"
        [includeInactive]="true"
        [includeInactiveLabel]="'screens.includeInactive'"
        [hasSearch]="true"
        [onSearch]="config.screenFilter.onSearch"
        [onLoadMore]="config.screenFilter.onLoadMore"
        [params]="config.screenFilter.params">
      </flow-form-combobox>
    </div>
  </form>

  <flow-button theme="primary" variation="fill" (onClick)="submit()" class="mt-8" [disabled]="form.invalid">
    <app-icon fill="none" [stroke]="'#fff'" iconName="file-check-02" size="md"></app-icon>
    <span>{{ "global.show" | translate }}</span>
  </flow-button>
</div>
